export default __webpack_public_path__ + "static/media/number-list-block-thumbnail-dark.c859bc43.svg";